export enum ECustomFieldType {
    FREE_TEXT = "Free text",
    DROPDOWN_LIST = "Drop down list",
    DATE_PICKER = "Date picker",
    DATE = "Date",
}